import React, { useState } from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import { useNotify } from 'react-admin';
import { getErrorMessage } from '../../utils/helperUtils.ts';
import { downloadContactsCsv, type ContactFilter } from '../contactExport.ts';
import { ShareContactsDialog } from './ShareContactsDialog.tsx';

type ContactShareButtonsProps = {
  // Scope to act on. ids wins over filter, matching the list behaviour.
  filter: ContactFilter;
  ids?: number[];
  scopeLabel: string;
  filename: string;
  dialogHeading: string;
  defaultSubject: string;
  defaultMessage: string;
  successMessage: string;
  size?: 'small' | 'medium';
  variant?: 'text' | 'outlined';
};

// Download and Share behave the same everywhere. The list scopes by selection
// or filter, the contact page scopes to the record that is open.
export const ContactShareButtons: React.FC<ContactShareButtonsProps> = ({
  filter,
  ids,
  scopeLabel,
  filename,
  dialogHeading,
  defaultSubject,
  defaultMessage,
  successMessage,
  size = 'medium',
  variant = 'outlined'
}) => {
  const notify = useNotify();
  const [shareOpen, setShareOpen] = useState(false);

  const handleDownload = async () => {
    try {
      await downloadContactsCsv(ids?.length ? { id: ids } : filter, filename);
    } catch (error) {
      notify(getErrorMessage(error), { type: 'error' });
    }
  };

  return (
    <>
      <Button
        size={size}
        variant={variant}
        startIcon={<DownloadIcon />}
        onClick={handleDownload}
      >
        Download {scopeLabel}
      </Button>
      <Button
        size={size}
        variant={variant}
        startIcon={<ShareIcon />}
        onClick={() => setShareOpen(true)}
      >
        Share {scopeLabel}
      </Button>

      <ShareContactsDialog
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        heading={dialogHeading}
        filter={ids?.length ? {} : filter}
        ids={ids}
        defaultSubject={defaultSubject}
        defaultMessage={defaultMessage}
        successMessage={successMessage}
      />
    </>
  );
};
